import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { Paper } from '../../components/Paper';
import { getNearbySummary } from '../../lib/api';
import { relativeTime } from '../../lib/time';
import { useFeed } from './queries';
import styles from './BoardAside.module.css';
import { FEED_REACH } from '../../../shared/region';

/** Desktop sidebar: a few plain facts about your board and recent lost & found. */
export function BoardAside() {
  const summary = useQuery({ queryKey: ['nearby', 'summary'], queryFn: getNearbySummary, staleTime: 5 * 60_000 });
  const lost = useFeed({ category: 'lost_found' }, { pageSize: 3 });
  const lostPosts = lost.data?.pages[0] ?? [];

  return (
    <>
      <Paper as="section" padded={false} className={styles.panel} aria-labelledby="aside-board">
        <h2 id="aside-board" className={styles.heading}>
          Your board
        </h2>
        {summary.data && (
          <ul className={styles.facts}>
            <li className={styles.fact}>
              <span className={styles.figure}>{summary.data.neighborCount}</span>
              <span>verified {summary.data.neighborCount === 1 ? 'neighbor' : 'neighbors'} nearby</span>
            </li>
            <li className={styles.fact}>
              <span className={styles.figure}>{summary.data.postsThisWeek}</span>
              <span>{summary.data.postsThisWeek === 1 ? 'note' : 'notes'} this week</span>
            </li>
          </ul>
        )}
        <p className={styles.small}>
          Everyone here verified that they live within {FEED_REACH} of you. Your board overlaps with theirs, so there
          are no hard borders between neighborhoods.
        </p>
      </Paper>

      {lostPosts.length > 0 && (
        <Paper as="section" padded={false} className={styles.panel} aria-labelledby="aside-lost">
          <h2 id="aside-lost" className={styles.heading}>
            Lost & found
          </h2>
          <ul className={styles.lostList}>
            {lostPosts.map((post) => (
              <li key={post.id} className={styles.lostItem}>
                <Link to={`/p/${post.id}`}>{post.body}</Link>
                <span className={styles.when}>{relativeTime(post.createdAt)}</span>
              </li>
            ))}
          </ul>
        </Paper>
      )}
    </>
  );
}
